import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Divider', 'heroTheme'], (token: FullToken) => {
  const { componentCls, lineWidth } = token

  return {
    [`${DOT_PREFIX}${componentCls}`]: {
      [`&${componentCls}-horizontal`]: {
        border: 'none',
        height: lineWidth,
        background: `linear-gradient(90deg, transparent, ${purple[500]}35, transparent)`,
      },
    },
  }
})
